export default __webpack_public_path__ + "static/media/Armbands of the Unholy Communion.d1e8fcd6.jpg";